<template>
    <div class="RequestDemoBar">
        <div class="request-demo-section">
            <div>
                <div class="title">
                    Predict your business, make informed decisions and <br> plan your resources better
                </div>
            </div>
            <el-button class="request-btn" @click="() => $router.push({ name: 'ContactUsRequestDemo' }).catch(()=>{})">Request Demo</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'RequestDemoBar'
}
</script>
<style lang="scss" scoped>
.RequestDemoBar{
    .request-demo-section{
        // background: linear-gradient(#5a66fa 0%, #212975 95.02%, #1e266e 100%, #1d266c 100%, #1e266e 100%)!important;
        background-color: #707070;
        // background-color: #232937;
        // border-bottom: 1px solid #b9bdbe;
        padding: 50px 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-around;

        .title{
            font-size: 25px;
            font-weight: 600;
            color: #fff;
            line-height: 1.5;
        }
        small{
            color: #fff;
            display: block;
        }

        .request-btn{
            border: 1px solid #e29d5a;
            background-color: #e29d5a;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
            padding: 5px;
            height: 50px;
            width: 150px;
            -webkit-transition: .3s;
            transition: .3s;
            margin: 35px;
        }
        .request-btn:hover{
            border: 1px solid #e29d5a;
            background-color: #e29d5a;
            color: #fff;
        }
    }
}
</style>
